// extracted by mini-css-extract-plugin
module.exports =  {"input":"_2787e5dfdf--input--LL5G7"};